var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { PICAction, PIC, PICBase, customElement, openChoiceBox, doSubmit, stringDecoder, stringDecoderLC, fetchRestApi } from '../Internals';
let PICHelp = class PICHelp extends PICBase {
    constructor() {
        super(...arguments);
        this.isHidden_ = true;
        this.selectType_ = 'spinner';
        this.eType = 'old';
        this.density = 'old';
    }
    get isHidden() {
        if (this.modal) {
            return this.modal.isHidden;
        }
        return this.isHidden_;
    }
    set isHidden(isHidden) {
        this.isHidden_ = isHidden;
        if (this.modal) {
            this.modal.isHidden = isHidden;
        }
        this.requestUpdate();
    }
    static get styles() {
        const defaultStyle = css `
        :host {

        }
        .bodycontainer {
            width: 100%;
        }
        .modal-text-container {
            margin: 2rem 0.5em
        }
        .cominfo-container{
            display: flex;
            justify-content: space-between;
            margin-bottom: 1rem;
        }
        .canvas-texarea-container {
            display: flex;
            flex-direction: row-reverse;
            gap: 10px;
            margin: 10px;
            align-items: start;
            justify-content: space-between;
        }
        .textarea-modal {
            width: 100%;
        }
        #dispcanvas {
            height: 170px;
            width: 100%;
            background-color: var(--pic-blackOverlayHoverColor);
        }
        li {
            list-style: none;
        }
        .info-box{
            width: 100%;
        }
        .info-box, .message-container{
            display: flex;
            flex-direction: column;
            gap: 10px;
        }
        .buttons-flex {
            display: flex;
            justify-content: space-between;
        }
        .input-selector-container {
            display: grid;
            gap: 10px;
            align-items: baseline;
            width: 100%;
            grid-template-columns: 1fr 1fr;
        }
        .inputs-styles-modal {
            gap: 0;
            display: flex;
            flex-direction: column;
        }
        .load-bundle-style {
            align-items: center;
            gap: 10px;
        }
        .footer {
            justify-content: space-between;
            display: flex;
            align-items: center;
            width: 100%;
        }
        .customer-footer {
            float: right;
        }

        .caption-style {
                margin-top: 5px;
        }
      
        `;
        return css `
          ${super.styles}
          ${defaultStyle}
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.sendAction = new PICAction();
        this.ssAction = new PICAction();
        this.picUserAction = new PICAction();
    }
    checkSend() {
        let ref = this;
        if (this.errfld.validState.length) {
            openChoiceBox('pic-choicebox[choicebox-x]', {
                choiceTitle: 'Your description is too long. Please shorten it to 20000 characters or less.',
                choices: [
                    { choiceText: 'Ok', choiceEvent: '' }
                ]
            });
            return;
        }
        if (!this.blobData && !this.errfld.submitValue) {
            openChoiceBox('pic-choicebox[choicebox-x]', {
                choiceTitle: 'Please take a screenshot and describe your problem before submitting your error',
                choices: [
                    { choiceText: 'Ok', choiceEvent: '' }
                ]
            });
            return;
        }
        if (!this.blobData) {
            openChoiceBox('pic-choicebox[choicebox-x]', {
                choiceTitle: 'You have not taken a screenshot, are you sure you want to submit your error report?',
                choices: [
                    { choiceText: 'Yes', choiceEvent: '', eventFnc: () => { ref.doSend(); } },
                    { choiceText: 'No', choiceEvent: '' }
                ]
            });
            return;
        }
        if (!this.errfld.submitValue) {
            openChoiceBox('pic-choicebox[choicebox-x]', {
                choiceTitle: 'You need to describe your problem before submitting to PICit support',
                choices: [
                    { choiceText: 'Ok', choiceEvent: '' }
                ]
            });
            return;
        }
        ref.doSend();
    }
    doSend() {
        var _a, _b, _c, _d, _e;
        let subject = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('help-subject')) === null || _b === void 0 ? void 0 : _b.submitValue;
        let priority = (_e = (_d = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.getElementById('help-priority')) === null || _d === void 0 ? void 0 : _d.selectedOption) === null || _e === void 0 ? void 0 : _e.val;
        let bodystr = ``;
        bodystr += `<h3>${subject ? subject : 'PIC Error mail'}</h3>`;
        bodystr += `<p><b>Error description:</b> ${this.errfld.submitValue}</p>`;
        bodystr += `<p><b>Priority:</b> ${priority ? priority : ''}</p>`;
        bodystr += `<h3>User Information</h3>`;
        bodystr += `<table style="border-collapse: collapse; border: 1px solid #ddd; width: 700px" cellpadding="0" cellspacing="0">`;
        bodystr += `<thead align="left">`;
        bodystr += `<tr style="border: 1px solid #ddd; background-color: #003767; color: #ffffff;"><th style="padding: 10px;">Name</th><th style="padding: 10px;">User Id</th><th style="padding: 10px;">Company</th><th style="padding: 10px;">Email</th><th style="padding: 10px;">Phone</th></tr>`;
        bodystr += `</thead>`;
        bodystr += `<tbody>`;
        bodystr += `<tr><td style="padding: 10px">${this.helpName.submitValue}</td><td style="padding: 10px">${this.helpUserId.submitValue}</td><td style="padding: 10px">${this.helpCompany.submitValue}</td><td style="padding: 10px">${this.helpEmail.submitValue}</td><td style="padding: 10px">${this.helpPhone.submitValue}</td></tr>`;
        bodystr += `</tbody>`;
        bodystr += `</table><br>`;
        bodystr += `<table style="border-collapse: collapse; border: 1px solid #ddd; width: 700px;" cellpadding="0" cellspacing="0">`;
        bodystr += `<thead><tr style="border: 1px solid #ddd;"><th style="padding: 10px; background-color: #e5edfb;" colspan="2">System Information</th></tr></thead>`;
        bodystr += `<tbody>`;
        bodystr += `<tr><td style="padding: 10px; border: 1px solid #ddd;"><b>User</b></td><td style="padding: 10px; border: 1px solid #ddd;">${PIC.user}</td></tr>`;
        bodystr += `<tr><td style="padding: 10px; border: 1px solid #ddd;"><b>Program</b></td><td style="padding: 10px; border: 1px solid #ddd;">${PIC.program}</td></tr>`;
        bodystr += `<tr><td style="padding: 10px; border: 1px solid #ddd;"><b>Session</b></td><td style="padding: 10px; border: 1px solid #ddd;">${PIC.sessionCode}</td></tr>`;
        bodystr += `<tr><td style="padding: 10px; border: 1px solid #ddd;"><b>System</b></td><td style="padding: 10px; border: 1px solid #ddd;">${PIC.systemId}</td></tr>`;
        bodystr += `<tr><td style="padding: 10px; border: 1px solid #ddd;"><b>Subwin</b></td><td style="padding: 10px; border: 1px solid #ddd;">${PIC.subwin}</td></tr>`;
        bodystr += `<tr><td style="padding: 10px; border: 1px solid #ddd;"><b>UserAgent</b></td><td style="padding: 10px; border: 1px solid #ddd;">${navigator.userAgent}</td></tr>`;
        bodystr += `<tr><td style="padding: 10px; border: 1px solid #ddd;"><b>Script Version</b></td><td style="padding: 10px; border: 1px solid #ddd;">${PIC.getInstance.appVersion}</td></tr>`;
        bodystr += `</tbody>`;
        bodystr += `</table><br>`;
        let tableString = `<table style="border-collapse: collapse; border: 1px solid #ddd; width: 700px;" cellpadding="0" cellspacing="0">`;
        tableString += `<thead><tr style="border: 1px solid #ddd;"><th style="padding: 10px; background-color: #e5edfb;" colspan="2">Input Field Values</th></tr></thead>`;
        tableString += `<tbody>`;
        for (let [id, element] of PIC.getInstance.picInputs) {
            if (id.startsWith('help-'))
                continue;
            tableString += `<tr><td style="padding: 10px; border: 1px solid #ddd;"><b>${id}</b></td><td style="padding: 10px; border: 1px solid #ddd;">${element.submitValue}</td></tr>`;
        }
        tableString += `</tbody>`;
        tableString += `</table><br>`;
        bodystr += tableString;
        bodystr = btoa(bodystr);
        let formData = new FormData();
        formData.append('SystemId', PIC.systemId);
        formData.append('SubWin', 'test/user/other/helpmail');
        formData.append('eventid', 'domail');
        formData.append('moduleId', 'test/user/other/helpmail');
        formData.append('SessionCode', PIC.sessionCode);
        formData.append('datemode', PIC.getInstance.datemode);
        formData.append('message', bodystr);
        if (!this.blobData) {
            fetch('/web', {
                method: 'POST',
                headers: [
                    ['Content-Type', 'application/x-www-form-urlencoded']
                ],
                body: new URLSearchParams(formData)
            }).then((e) => {
                console.log('Success', e);
            }).catch((e) => { console.log('Error', e); });
        }
        else {
            blobToBase64(this.blobData).then((base64Data) => {
                base64Data = base64Data.replace('data:image/png;base64,', '');
                formData.append('image', base64Data);
                fetch('/web', {
                    method: 'POST',
                    headers: [
                        ['Content-Type', 'application/x-www-form-urlencoded']
                    ],
                    body: new URLSearchParams(formData)
                }).then((e) => {
                    console.log('Success', e);
                }).catch((e) => { console.log('Error', e); });
            })
                .catch((e) => {
                console.log('Base64 conversion error', e);
            });
        }
        function blobToBase64(blob) {
            return new Promise((resolve, _) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.readAsDataURL(blob);
            });
        }
    }
    handleSS() {
        //hide self for screenshot
        this.isHidden = true;
        // create work canvas
        let workCanvas = document.createElement('canvas');
        // finds displaySurface's type, for starting on the window-tab
        let constraints = {
            video: {
                displaySurface: "window"
            }
        };
        // Request media
        navigator.mediaDevices.getDisplayMedia(constraints).then(stream => {
            // Grab frame from stream
            let track = stream.getVideoTracks()[0];
            //TODO streamline post blob work on workcanvas so both chromium & ff / wk use same finisher
            if ('ImageCapture' in window) {
                // Chromium 
                // @ts-ignore: grabFrame is not in TypeScript's ImageCapture yet
                let capture = new window.ImageCapture(track);
                capture.grabFrame().then((bitmap) => {
                    var _a;
                    // Stop sharing
                    track.stop();
                    // Draw the bitmap to canvas
                    workCanvas.width = bitmap.width;
                    workCanvas.height = bitmap.height;
                    (_a = workCanvas.getContext('2d')) === null || _a === void 0 ? void 0 : _a.drawImage(bitmap, 0, 0);
                    resizeAndDisplay(workCanvas, this);
                    // Grab blob from canvas
                    workCanvas.toBlob((blob) => {
                        // Do things with blob here
                        blob.name = `screenshot-${new Date().getTime()}.png`;
                        // copy to clipboard
                        let data = [new ClipboardItem({ [blob.type]: blob })];
                        navigator.clipboard.write(data);
                        this.blobData = blob;
                        console.log('output blob:', blob);
                        //show 
                        this.isHidden = false;
                    });
                });
            }
            else {
                // Firefox / webkit
                let video = document.createElement('video');
                let context = workCanvas.getContext('2d');
                video.srcObject = stream;
                return new Promise((resolve, reject) => {
                    video.addEventListener('loadeddata', async () => {
                        let { videoWidth, videoHeight } = video;
                        workCanvas.width = videoWidth;
                        workCanvas.height = videoHeight;
                        try {
                            await video.play();
                            context === null || context === void 0 ? void 0 : context.drawImage(video, 0, 0, videoWidth, videoHeight);
                            workCanvas.toBlob(resolve, 'image/png');
                        }
                        catch (error) {
                            // Stop sharing
                            track.stop();
                            reject(error);
                            //show 
                            this.isHidden = false;
                        }
                    });
                }).then((blob) => {
                    blob.name = `screenshot-${new Date().getTime()}.png`;
                    this.blobData = blob;
                    resizeAndDisplay(workCanvas, this);
                    // Stop sharing
                    track.stop();
                    //show 
                    this.isHidden = false;
                });
            }
        }).catch(e => console.log(e));
        function resizeAndDisplay(iWorkCanvas, helpRef) {
            helpRef.dispCanvas.width = 576;
            helpRef.dispCanvas.height = 324;
            let ctx = helpRef.dispCanvas.getContext('2d');
            ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(iWorkCanvas, 0, 0, iWorkCanvas.width, iWorkCanvas.height, 0, 0, 576, 324);
        }
    }
    handlePicUser() {
    }
    firstUpdated() {
        this.sendAction.type_ = 'internal';
        this.sendAction.eventFnc = this.checkSend.bind(this);
        this.ssAction.type_ = 'internal';
        this.ssAction.eventFnc = this.handleSS.bind(this);
        this.picUserAction.type_ = 'internal';
        this.picUserAction.eventFnc = this.handlePicUser.bind(this);
        if (PIC.user) {
            fetchRestApi(null, {
                httpMethod: 'GET',
                path: `core/users/${PIC.user}`,
                picsystem: PIC.systemId
            }).then(res => res.json())
                .then(json => {
                var _a, _b, _c, _d, _e, _f, _g;
                if (json) {
                    this.helpName.value = (_a = json.userName) !== null && _a !== void 0 ? _a : '';
                    this.helpUserId.value = (_b = json.userId) !== null && _b !== void 0 ? _b : '';
                    this.helpCompany.value = (_c = json.companyNameShort) !== null && _c !== void 0 ? _c : '';
                    if (!this.helpCompany.value)
                        this.helpCompany.value = (_d = json.companyName) !== null && _d !== void 0 ? _d : '';
                    this.helpEmail.value = (_e = json.userEmail) !== null && _e !== void 0 ? _e : '';
                    this.helpPhone.value = (_f = json.userPhone) !== null && _f !== void 0 ? _f : '';
                    if (!this.helpPhone.value)
                        this.helpPhone.value = (_g = json.companyPhone) !== null && _g !== void 0 ? _g : '';
                }
            });
        }
    }
    renderPICinfo() {
        /* split into seperate divs for easier copy pasting  */
        return html `
        <div class="load-bundle-style">${renderToolActions()}
            <div style="display:inline-flex;">
            <div>Prog:</div>
            <div>&nbsp;${PIC.moduleId}</div>
            </div>
        </div> 
        `;
        function renderToolActions() {
            if (PIC.isTeamTools) {
                let toolAction = new PICAction();
                toolAction.type_ = 'internal';
                toolAction.eventFnc = () => {
                    window.loadNewBundle = true;
                    //should always happen in lightdom
                    doSubmit('refresh');
                };
                return html `<pic-button label='loadNewBundle' .action=${toolAction} etype='contained' density='high' width=180></pic-button>`;
            }
            return '';
        }
    }
    renderButtonInfo() {
        var _a;
        return html `
            <div class="modal-text-container">
                <div class="cominfo-container">
                    <div class="pic-h6 new"><strong>Use this to send an email to the support department.</strong></div>
                    ${((_a = PIC.user) === null || _a === void 0 ? void 0 : _a.split('_')[0]) == 'picit' ?
            html `
                        <pic-button label='Se comminfo' loadpagepath="/util/comminfo" loadpageparm=${btoa('commInfo')} .isNew=${true} class="help bottomBtn"
                        etype="outlined" density='high' width=150>Se comminfo</pic-button>` :
            ''}
                </div>
                <div class="pic-body2">Describe your problem and the support staff will get back to you. <strong>Please </strong>remember to include all relevant contact informations.</div>
                    <div class="pic-caption new caption-style">
                       Mon - Fri: 8 - 16, Phone: +45 87 30 80 20  
                    </div>
            </div>
        `;
    }
    render() {
        var _a;
        let isPicItUser = ((_a = PIC.user) === null || _a === void 0 ? void 0 : _a.split('_')[0]) === 'picit';
        return html `
        <pic-modal 
            .isNew=${true} 
            .isHidden=${this.isHidden} 
            .title_=${isPicItUser ? 'Help - own bugreport' : 'Help'} 
            .parent=${this}>
            <div slot="slot-modal-body" class="bodycontainer">  
                ${this.renderButtonInfo()}
                <div class="canvas-texarea-container">
                    <div class="info-box">
                        <div class="inputs-styles-modal">
                            <pic-text class="inputFld" id="help-name" etype="default" label="Contact information" placeholder="Name" density="high" width=100%></pic-text>
                            <pic-text class="inputFld" id="help-userId" etype="default" placeholder="User id" density="high" width=100%></pic-text>
                            <pic-text class="inputFld" id="help-company" etype="default" placeholder="Company" density="high" width=100%></pic-text>
                            <pic-text class="inputFld" id="help-email" etype="default" placeholder="Email" density="high" width=100%></pic-text>
                            <pic-text class="inputFld" id="help-phone" etype="default" placeholder="Phone" density="high" width=100%></pic-text>
                        </div>
                        <canvas id='dispcanvas'></canvas>
                        <pic-button label='Take screenshot' .action=${this.ssAction} etype='outlined' density='high' width=100% slot="slot-modal-footer"></pic-button>
                    </div>
                    <div class="message-container">
                        <div class="input-selector-container">
                            <pic-text id="help-subject" label="Subject" etype="default" density="high" width=235></pic-text>
                            <pic-selector id="help-priority" selectedOption="firstOp" label="Priority" selecttype="spinner" etype='default' density='high' width=100%>
                                <pic-optiongroup minchars="0">
                                    <data key="firstOp" val="At first opportunity"></data>
                                    <data key="asap" val="As soon as possible"></data>
                                    <data key="emergency" val="Emergency"></data>
                                    <data key="sendOffer" val="Please send me an offer"></data>
                                </pic-optiongroup>
                            </pic-selector>
                        </div>
                        <pic-textarea 
                            class="textarea-modal" 
                            id="help-errfld" 
                            label='Error description' 
                            etype='default' 
                            density='medium' 
                            rows=9 
                            width="480px" 
                            tooltip="Please describe the error you are experiencing and include as many details as possible." 
                            .validateData=${{ rules: [{ ruleType: 'maxlength', value: '20000', errorMessage: 'Max length is 20000 characters' }] }}
                            .showcharactercount=${true}
                            ></pic-textarea>
                    </div> 
                </div>
            </div>
            <div slot="slot-modal-footer" class="footer">
                ${isPicItUser ? this.renderPICinfo() : ''}
                <div><pic-button label='Send to PICit' .action=${this.sendAction} eType='contained' density='high' width=150 slot="slot-modal-footer"></pic-button></div>
            </div>  
        </pic-modal>
    `;
    }
};
__decorate([
    query('pic-modal')
], PICHelp.prototype, "modal", void 0);
__decorate([
    property({ reflect: true, attribute: 'selecttype', converter: stringDecoder })
], PICHelp.prototype, "selectType_", void 0);
__decorate([
    query('#dispcanvas')
], PICHelp.prototype, "dispCanvas", void 0);
__decorate([
    property({ converter: stringDecoderLC, attribute: 'etype' })
], PICHelp.prototype, "eType", void 0);
__decorate([
    property({ converter: stringDecoderLC, attribute: 'density' })
], PICHelp.prototype, "density", void 0);
__decorate([
    query('#help-errfld')
], PICHelp.prototype, "errfld", void 0);
__decorate([
    query('#help-name')
], PICHelp.prototype, "helpName", void 0);
__decorate([
    query('#help-userId')
], PICHelp.prototype, "helpUserId", void 0);
__decorate([
    query('#help-company')
], PICHelp.prototype, "helpCompany", void 0);
__decorate([
    query('#help-email')
], PICHelp.prototype, "helpEmail", void 0);
__decorate([
    query('#help-phone')
], PICHelp.prototype, "helpPhone", void 0);
PICHelp = __decorate([
    customElement('pic-help')
], PICHelp);
export { PICHelp };
//# sourceMappingURL=PICHelp.js.map